import googlePythonCertificate from "../../assets/images/certificate-google-python.png";
import linkedinPythonCertificate from "../../assets/images/certificate-linkedin-python.png";
import linkedin1Certificate from "../../assets/images/certificate-AWS essential training for developers.png";
import linkedin2Certificate from "../../assets/images/certificate-bootstrap 5 essential training.png";
import linkedin3Certificate from "../../assets/images/certificate-building web APIs with ASP.NET core in .NET.png";
import linkedin4Certificate from "../../assets/images/certificate-ChatGPT for web developers.png";
import linkedin5Certificate from "../../assets/images/certificate-designing RESTful APIs.png";
import linkedin6Certificate from "../../assets/images/certificate-DevOps foundations_continuous delivery, continuous integration.png";
import linkedin7Certificate from "../../assets/images/certificate-learning Amazon Web Services AWS for developers.png";
import linkedin8Certificate from "../../assets/images/certificate-learning Next.js.png";
import linkedin9Certificate from "../../assets/images/certificate-learning TypeScript.png";
import linkedin10Certificate from "../../assets/images/certificate-Node.js Web Servers Tests and Deployment.png";
import linkedin11Certificate from "../../assets/images/certificate-React Creating and Hosting a FullStack Site.png";
import linkedin12Certificate from "../../assets/images/certificate-React Design Patterns.png";
import linkedin13Certificate from "../../assets/images/certificate-SQL Essential Training.png";
import linkedin14Certificate from "../../assets/images/certificate-Test Automation Foundations.png";
import linkedin15Certificate from "../../assets/images/certificate-TypeScript Essential Training.png";
import googleAICertificate from "../../assets/images/certificate-google ai esssential.png";

const CertificateElements = [
  { href: "https://www.coursera.org/account/accomplishments/verify/KYTC9F0O7QZ1", src: googleAICertificate },
  { href: "https://www.coursera.org/account/accomplishments/certificate/JETFTWUP45LA", src: googlePythonCertificate },
  {
    href: "https://www.linkedin.com/learning/certificates/bf82ca1a9b6d57b21e4a2d0f05f7b3e601326bd52addf0420a04f80594daec69?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin1Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/dd8689fd928e1dcb12c9c1ebec9f58cab68156f685d6510edb11760fac8bdbc1?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin2Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/c6b02df60bcae306c77731fa8413c4728a71f914dac1fb301f3361a2b1715408?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin3Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/d8e30ff75ff403c25a77568923697086a528585d3c9db7ba020f66f4639ccb51?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin4Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/a36e6b0e191b8b024327f4dfe0b439690445e1cc9717beeca7edfa2718155828?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin5Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/61ea0c2a334b98c96288905058a4045ee356f2202166b706ae0bce613132c293?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin6Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/b5a57f5c05b6ccd9787971ac28625e8f2828861ff76ecd32d9834369ee599e36?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin7Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/9d582fe62154287a8a3187949f6d76f0e75003b288ca79b37cec6c94e324355e?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin8Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/fa8a79fe77c4f2bef25e2787de957ff1112b5e5b5b85cb6bc32ac06b77f94028?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin9Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/7df85354e41eb22a2c3d91c401e76cd1b0c9ac752e8498638ee775dcd868ca28?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin10Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/4d6b27b35fbf68034e1a32835c896296ef6fcec410d15463432447505e5f36c9?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin11Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/03d1e528a7a09483d929f96f29f4c786fbebc146a76f827ca9c05d4c68ab49e2?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin12Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/d2c6236902b23995b6d47352c03e2fde78d95c2c7ebc05832b54b27273a130f8?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin13Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/268f35a6bb3bdda35e9b05e783e7b6df89a79dd0334aaa716bf889f9616506f6?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin14Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/5503de1e03643e55b48b5c804c6ff2f13fae3c6ee661ef26d7014cd23f0c2cea?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BTvtWjc3iSwaTiDrWhwPN1g%3D%3D",
    src: linkedin15Certificate,
  },
  {
    href: "https://www.linkedin.com/learning/certificates/4587491b45d1e1a974f960690ac44d28017999aaf4ec133cd7178779a36d0eda?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BqwwPVlP0TpaiKaKZe0JuPA%3D%3D",
    src: linkedinPythonCertificate,
  },
];

export default CertificateElements;
